import Splide from "@splidejs/splide";

export const mvSlider = () => {
  if (document.querySelector(".js-mv-slider") === null) {
    return;
  }

  const mvLogo = document.querySelector(".js-mv-logo");

  const slider = new Splide(".js-mv-slider", {
    pauseOnHover: false,
    resetProgress: false,
    pagination: false,
    autoplay: true,
    arrows: false,
    type: "fade",
    rewind: true,
    interval: 8000,
    speed: 5000,
    updateOnMove: true,
  });

  // 初回
  slider.on("mounted", function () {
    console.log("mounted");

    const firstSlide = document.querySelector(".mv-slider__slide:nth-child(1)");
    const logoColor = firstSlide.dataset.logoColor;

    if (logoColor === "black") {
      mvLogo.classList.add("is-black");
      mvLogo.classList.remove("is-white");
    } else {
      mvLogo.classList.remove("is-black");
      mvLogo.classList.add("is-white");
    }
  });

  // スライドが切り替わる直前
  slider.on("move", function (newIndex) {
    console.log(newIndex);
    const newSlide = document.querySelector(`.mv-slider__slide:nth-child(${newIndex + 1})`);
    const logoColor = newSlide.dataset.logoColor;

    if (logoColor === "black") {
      mvLogo.classList.add("is-black");
      mvLogo.classList.remove("is-white");
    } else {
      mvLogo.classList.remove("is-black");
      mvLogo.classList.add("is-white");
    }
  });

  slider.mount();
};
